import type { IconGlyph } from '../icon';

import { iconSearchThick } from './search-thick';

/**
 * Tractie `search` glyph (medium, 24×24).
 *
 * Source: `@tractie/icons` v1.2.1 — `dist/jsx/m/search.jsx`.
 * Verbatim copy of the SVG `d` attribute.
 */
export const iconSearch: IconGlyph = {
  fillRule: 'evenodd',
  name: 'search',
  path: 'm20.86 20.16-4.72-4.72a7.45 7.45 0 0 0 1.85-4.94c0-4.14-3.36-7.5-7.5-7.5s-7.5 3.36-7.5 7.5 3.36 7.5 7.5 7.5c1.89 0 3.62-.7 4.94-1.85l4.72 4.72c.2.2.51.2.71 0s.2-.51 0-.71M10.5 17a6.5 6.5 0 1 1 0-13 6.5 6.5 0 0 1 0 13',
  selected: iconSearchThick,
};
